import { FC } from "react";
import InfoModal from "@/components/modal/info";
import { useTranslation } from "react-i18next";
import useModalsStore from "@/stores/modals";
import { playSound, SoundOption } from "@/helpers/playSound";
import InvalidQrModal from "@/components/qr-modal";

const ErrorInfoModals: FC = () => {
  const { t } = useTranslation();
  const { isInvalidQrModalOpen } = useModalsStore();

  const {
    voucherNotValidReason,
    setVoucherNotValidReason,
    voucherNotFound,
    setVoucherNotFound,
    unknownError,
    setUnknownError,
  } = useModalsStore();

  const onNotValidReasonClose = () => {
    setVoucherNotValidReason(undefined);
    playSound(SoundOption.Click2Lo);
  };

  if (isInvalidQrModalOpen) return <InvalidQrModal />;

  if (voucherNotValidReason) {
    return (
      <InfoModal
        onClose={onNotValidReasonClose}
        title={t("mainPage.vouchers.notValidTitle")}
        description={voucherNotValidReason}
        testId="voucher-error"
      />
    );
  }

  const onErrorClose = () => {
    if (unknownError) return setUnknownError(false);
    setVoucherNotFound(false);
    playSound(SoundOption.Click2Lo);
  };

  if (unknownError || voucherNotFound)
    return (
      <InfoModal
        onClose={onErrorClose}
        title={t(
          unknownError ? "mainPage.errors.unknownErrorTitle" : "mainPage.errors.notFoundTitle"
        )}
        description={t(
          unknownError
            ? "mainPage.errors.unknownErrorDescription"
            : "mainPage.errors.notFoundDescription"
        )}
        testId={unknownError ? "unknown-error" : "voucher-not-found"}
      />
    );

  return null;
};

export default ErrorInfoModals;
